module.exports = __webpack_public_path__ + "img/StateVan.fd087c3f.gif";